import React from 'react';
import { ClassRecord } from '../../data/classes';
import { ClassCard } from './ClassCard';
interface ClassListProps {
  classes: ClassRecord[];
  onClassClick: (classRecord: ClassRecord) => void;
}
export function ClassList({
  classes,
  onClassClick
}: ClassListProps) {
  if (classes.length === 0) {
    return <div className="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200" data-id="element-154">
        <p className="text-gray-500 text-lg" data-id="element-155">
          No classes match these filters. Try resetting your filters or
          selecting another category.
        </p>
      </div>;
  }
  // Group classes by month
  const groupedClasses = classes.reduce((acc, cls) => {
    const date = new Date(cls.date + 'T00:00:00');
    const monthYear = date.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
    if (!acc[monthYear]) {
      acc[monthYear] = [];
    }
    acc[monthYear].push(cls);
    return acc;
  }, {} as Record<string, ClassRecord[]>);
  return <div className="space-y-12" data-id="element-156">
      {Object.entries(groupedClasses).map(([monthYear, monthClasses]) => <div key={monthYear} data-id="element-157">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-brand-purple-100" data-id="element-158">
            {monthYear}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-159">
            {monthClasses.map(cls => <ClassCard key={cls.id} classRecord={cls} onClick={onClassClick} data-id="element-160" />)}
          </div>
        </div>)}
    </div>;
}